export default "__VITE_ASSET__C84l0rJE__"